{
  "title": "Greater Invisibility",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level illusion",
  "level": 4,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You or a creature you touch becomes invisible until the spell ends. Anything the target is wearing or carrying is invisible as long as it is on the target’s person."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "wizard"]
}
